import { get } from 'lodash-es';
import { createSelector } from 'reselect';

import { emptyArray, emptyObject } from 'ui-components/default-props/empty';
import type { BatchDetailsBatch, BatchDetailsJob, BatchDetailsState } from './batch.details.types';
import type { FilterBarAppliedFilter } from '../../../prop-types/applied-filter';
import type { RootState } from 'store/root-state';

export const selectBatch = (state: BatchDetailsState): BatchDetailsBatch => get(state, 'batch', emptyObject);
export const selectAppliedFilters = (state: BatchDetailsState): FilterBarAppliedFilter[] =>
  get(state, 'appliedFilters', emptyArray as FilterBarAppliedFilter[]);
export const selectIsLoading = (state: BatchDetailsState): boolean => get(state, 'isLoading');
export const selectMoveToBatchModalId = (state: BatchDetailsState): string | undefined => get(state, 'moveToBatchModalId');
export const selectAddressValidationJobs = (state: BatchDetailsState): BatchDetailsJob[] =>
  get(state, 'addressValidationJobs', emptyArray as BatchDetailsJob[]);
export const selectSelectedViewId = (state: BatchDetailsState): string => get(state, 'selectedViewId');
export const selectRateBatchJobs = (state: BatchDetailsState): BatchDetailsJob[] =>
  get(state, 'rateBatchJobs', emptyArray as BatchDetailsJob[]);
export const selectShipmentNotificationJobs = (state: BatchDetailsState): string[] =>
  get(state, 'shipmentNotificationJobs', emptyArray as string[]);
export const selectHasNameConflict = (state: BatchDetailsState): boolean => get(state, 'hasNameConflict');
export const selectFulfillmentPlanSetId = (state: BatchDetailsState): string | undefined => get(state, 'batch.fulfillmentPlanSetId');
export const selectBatchReceivingFulfillmentPlans = (state: BatchDetailsState): string | null =>
  get(state, 'batchReceivingFulfillmentPlans');

export const selectIsAddingToBatch = createSelector(
  selectBatchReceivingFulfillmentPlans,
  (batchReceivingFulfillmentPlans) => !!batchReceivingFulfillmentPlans,
);

export const selectBatchDetailsAddressValidationJobs = (state: RootState): BatchDetailsJob[] =>
  selectAddressValidationJobs(get(state, 'batches.details'));
export const selectBatchDetailsAppliedFilters = (state: RootState): FilterBarAppliedFilter[] =>
  selectAppliedFilters(get(state, 'batches.details'));
export const selectBatchDetailsBatch = (state: RootState): BatchDetailsBatch => selectBatch(get(state, 'batches.details'));
export const selectBatchDetailsBatchReceivingFulfillmentPlans = (state: RootState): string | null =>
  selectBatchReceivingFulfillmentPlans(get(state, 'batches.details'));
export const selectBatchDetailsFulfillmentPlanSetId = (state: RootState): string | undefined =>
  selectFulfillmentPlanSetId(get(state, 'batches.details'));
export const selectBatchDetailsHasNameConflict = (state: RootState): boolean => selectHasNameConflict(get(state, 'batches.details'));
export const selectBatchDetailsIsAddingToBatch = (state: RootState): boolean => selectIsAddingToBatch(get(state, 'batches.details'));
export const selectBatchDetailsIsLoading = (state: RootState): boolean => selectIsLoading(get(state, 'batches.details'));
export const selectBatchDetailsMoveToBatchModalId = (state: RootState): string | undefined =>
  selectMoveToBatchModalId(get(state, 'batches.details'));
export const selectBatchDetailsRateBatchJobs = (state: RootState): BatchDetailsJob[] => selectRateBatchJobs(get(state, 'batches.details'));
export const selectBatchDetailsSelectedViewId = (state: RootState): string => selectSelectedViewId(get(state, 'batches.details'));
export const selectBatchDetailsShipmentNotificationJobs = (state: RootState): string[] =>
  selectShipmentNotificationJobs(get(state, 'batches.details'));
